import proxy from "../proxy";
const chat = {
  list:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("chat/list", data, { dispatch }),
  info:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("chat/info", data, { dispatch }),
  bio:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("chat/bio", data, { dispatch }),
  update:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.put("blog/update", data);
      await proxy.get("blog/list", data2, { dispatch });
    },
  add:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.post("blog/add", data);
      await proxy.get("blog/list", data2, { dispatch });
    },
  del:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.delete("blog/delete", data);
      await proxy.get("blog/list", data2, { dispatch });
    },
};

export default chat;
